// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__az4of"};